module.exports = __webpack_public_path__ + "img/google-slides-1.66f464af.webp";